export const routes = [
  {
    path: '/exportar-relatorio',
    component: () => import(/* webpackChunkName: "report" */ './components/Export'),
    name: 'report.export',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/relatorio',
    component: () => import(/* webpackChunkName: "report" */ './components/List'),
    name: 'report.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/relatorio/inserir',
    component: () => import(/* webpackChunkName: "report" */ './components/Insert'),
    name: 'report.insert',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/relatorio/obter/:relatorio',
    component: () => import(/* webpackChunkName: "report" */ './components/Get'),
    name: 'report.get',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/obter_publico/:relatorio',
    component: () => import(/* webpackChunkName: "report" */ './components/Get_public'),
    name: 'report.get_public',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/analisar-relatorios',
    component: () => import(/* webpackChunkName: "report" */ './components/Analyse'),
    name: 'report.analyse',
    meta: {
      requiresAuth: true
    }
  }
]
